import React from "react";
import useAppSelector from "../../../../../../hooks/redux/base/useAppSelector";
import { baseEndpointPaths } from "../../../../../../services/serviceCalls";
import FilingForm from "../../../common/form/filing/FilingForm";

const SeAdditionalDocStepFiling = () => {
  const seAdditionalDocForm = useAppSelector((state) => {
    return state.Forms.SeAdditionalDocForm;
  });

  return (
    <FilingForm
      basePath={baseEndpointPaths.seAdditionalDoc}
      appId={seAdditionalDocForm.id}
      allowedFileApplicationAction={false}
    />
  );
};
export default SeAdditionalDocStepFiling;
